import React from 'react';
import { type Activity, type Message } from 'botframework-directlinejs';
import { type IAIMessage, type IAdsCopilotProps, type IActivityRenderer, type IActivityRendererProps } from '@bingads-webui/ads-copilot-ui';
import { type I18nModel } from '@bingads-webui/copilot-i18n';
import { type ILogger } from '@bingads-webui-react/copilot-utils';

export interface LogEventProps {
  featureName?: string;
  data?: Record<string, any>;
}

export interface IFeatureLogger {
  error: (props: LogEventProps) => void;
  trace: (props: LogEventProps) => void;
}

// eslint-disable-next-line no-shadow
export enum LiveAgentQueue {
  General = 'general',
  Optimization = 'optimization',
  Agency = 'agency',
  ShoppingAndUET = 'complex',
}

export type TokenListItem = {
  queue: string;
  token: string;
};

export type LiveAgentActivityProps = {
  isAIDegraded?: boolean;
  locale?: string;
  onLiveAgentTokensReceive: (tokens: TokenListItem[]) => void;
  onLiveAgentTransferClick: (activityId: string, queue?: LiveAgentQueue, problemDescription?: string) => void;
};

export type ActivityRendererProps = IActivityRendererProps & {
  logger: ILogger;
  featureLogger?: IFeatureLogger;
  onFeedbackButtonClick: IAIMessage['onFeedbackButtonClick'];
  renderFeedbackButtons?: (message: Message) => React.JSX.Element;
  onConnectToSupport?: () => void;
  renderTroubleshootingSiteLinks: (troubleshootingRecommendation: any, replyToId?: string) => React.JSX.Element;
  onFullInsightsClick?: (ev: React.MouseEvent<HTMLButtonElement>, replyToId: string | undefined, options: { onFeedbackButtonClick: ActivityRendererProps['onFeedbackButtonClick'], i18n: I18nModel | null }) => void;
  isAIDegradedModeEnabled?: boolean;
  botServiceConfig: IAdsCopilotProps['botServiceConfig'];
  getCampaigns?: () => Promise<Array<{ name: string, id: string }>>;
  onMissingParamsSubmit?: (text: string) => void;
  showTagTestResult?: boolean;
  isReportingInsights15Enabled?: boolean;
  isCustomizedEventBusy?: boolean;
  isInlineLiveAgentButtonEnabled?: boolean;
  isUpdateContextProviderEnabled?: boolean;
  isActionAgentEnabled?: boolean;
  liveAgentActivityProps: LiveAgentActivityProps;
  renderLiveAgentAction?: (activity: Activity) => React.JSX.Element;
  renderAction?: (activity: Activity) => React.JSX.Element;
  additionalContext?: Record<string, any>;
  getTailorContext?: () => Record<string, any>;
  isPageContextEnabled?: boolean;
};

export type ActivityRenderer = IActivityRenderer<ActivityRendererProps>;
